import { TLocation } from 'shared/types/location';

const REGION_MOSCOW_MO = -1;
const REGION_SPB_LO = -2;

export const prepareRegionId = (location: TLocation): number => {
  if (!location) {
    return REGION_MOSCOW_MO;
  }

  switch (location) {
    case 'moscow_mo':
      return REGION_MOSCOW_MO;
    case 'spb_lo':
      return REGION_SPB_LO;
    default:
      return location.id;
  }
};
